/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AgentCrmViewDataQueryVariables = Types.Exact<{
  params: Types.Scalars['JSON']['input'];
}>;


export type AgentCrmViewDataQuery = { agentViewData: { __typename: 'AgentViewDataResult', data: any } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };


export const AgentCrmViewDataDocument = gql`
    query AgentCrmViewData($params: JSON!) {
  agentViewData(component: "crm_table", params: $params) {
    __typename
    ... on AgentViewDataResult {
      data
    }
  }
}
    `;

/**
 * __useAgentCrmViewDataQuery__
 *
 * To run a query within a React component, call `useAgentCrmViewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentCrmViewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentCrmViewDataQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAgentCrmViewDataQuery(baseOptions: Apollo.QueryHookOptions<AgentCrmViewDataQuery, AgentCrmViewDataQueryVariables> & ({ variables: AgentCrmViewDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentCrmViewDataQuery, AgentCrmViewDataQueryVariables>(AgentCrmViewDataDocument, options);
      }
export function useAgentCrmViewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentCrmViewDataQuery, AgentCrmViewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentCrmViewDataQuery, AgentCrmViewDataQueryVariables>(AgentCrmViewDataDocument, options);
        }
export function useAgentCrmViewDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentCrmViewDataQuery, AgentCrmViewDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentCrmViewDataQuery, AgentCrmViewDataQueryVariables>(AgentCrmViewDataDocument, options);
        }
export type AgentCrmViewDataQueryHookResult = ReturnType<typeof useAgentCrmViewDataQuery>;
export type AgentCrmViewDataLazyQueryHookResult = ReturnType<typeof useAgentCrmViewDataLazyQuery>;
export type AgentCrmViewDataSuspenseQueryHookResult = ReturnType<typeof useAgentCrmViewDataSuspenseQuery>;
export type AgentCrmViewDataQueryResult = Apollo.QueryResult<AgentCrmViewDataQuery, AgentCrmViewDataQueryVariables>;